import {I18nProvider as LinguiProvider} from '@lingui/react';
import {I18nManager, Platform} from 'react-native';
import {useEffect} from 'react';
import device from 'extensions/device';

import {load, i18n, isRTL} from './loader';

load('en');
i18n.activate('en');

export function I18nProvider(props: React.PropsWithChildren<{}>) {
  useEffect(() => {
    const locale = device.getLocale(true);
    const isRtl = isRTL(locale);
    if (Platform.OS === 'web') {
      document.documentElement.dir = isRtl ? 'rtl' : 'ltr';
    } else {
      I18nManager.forceRTL(isRtl);
    }
    load(locale);
  }, []);

  return (
    <LinguiProvider {...{i18n}}>
      {props.children}
    </LinguiProvider>
  );
}
